import { constants } from "@newsela/angelou";

const { ui } = constants.colors;
const core700 = ui.core[700];
const neutral400 = ui.neutral[400];
const neutral700 = ui.neutral[700];
const white = ui.white[700];

export const buttonCss = {
  "--angelou-svg-primary-color": neutral700,

  background: white,
  color: neutral400,
  justifyContent: "space-between",
  maxWidth: "calc(100vw - 32px)",
  width: "288px",
  /**
   * Use  box-shadow since Safari ignores border-radius + outline.
   * Use transparent outline since Windows High Contrast Mode
   * ignores box-shadow and using border results in layout shift
   * when changing border-width on focus.
   */
  border: "none",
  boxShadow: `0 0 0 1px ${neutral400}`,
  outline: "1px solid transparent",

  ":focus-within": {
    backgroundColor: white,
    boxShadow: `0 0 0 2px ${core700}`,
  },
};

export const buttonContentsCss = (isNewselaRecommended) => {
  return {
    width: "100%",
    color: isNewselaRecommended ? neutral400 : neutral700,

    "> span": {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
    },
  };
};

export const popOutCss = {
  root: {
    zIndex: 1,
  },
};
